import { useRef } from 'react';
import { useLocation } from '@remix-run/react';
import { Box } from '~/components/wrappers/Box';
import DesktopSidebar from './Desktop';
import styled from 'styled-components';
import { zIndex } from '~/theme/zIndex';
import useIsMobileNavigation from '~/common/hooks/useIsMobileNavigation';
import { Routes } from '~/common/constants/routes';

interface ISidebar {
  activeTab?: string;
}

const Sidebar = ({ activeTab }: ISidebar) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const showMobile = useIsMobileNavigation();
  const { pathname } = useLocation();

  if (showMobile) return null;
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  if (normalizedPath === Routes.SecretEvent) return null;

  return (
    <Box $zIndex={zIndex.modal}>
      <SidebarFixed ref={sidebarRef}>
        <DesktopSidebar activeTab={activeTab} />
      </SidebarFixed>
    </Box>
  );
};

const SidebarFixed = styled(Box)`
  position: fixed;
  bottom: 0;
  width: fit-content;
  z-index: ${({ theme }) => theme.zIndex.modal};

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-left: 0;
    z-index: auto;
  }
`;

export default Sidebar;
